import React, { useEffect, useRef, useState } from 'react'
import { getFlyerData } from '../../utils/urls';
import { useSelector } from 'react-redux';
import axios from '../../utils/axios';
import FlexComponent from '../../components/FlexComponent';
import adminLogo from '../../Images/admin_img.jpg'
import { Toast } from 'primereact/toast';
import { Avatar } from 'primereact/avatar';
import FlyerPdf from '../../components/apps/flyer/FlyerPdf';
import AppModal from '../../shared/AppModal';
import { ProgressSpinner } from 'primereact/progressspinner';

function FlyerLibrary() {
    const userId = useSelector(state => state.user.userId);
    const [flyerData, setFlyerData] = useState([])
    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);
    const toast = useRef(null);
    const [isFlyerOpen, setIsFlyerOpen] = useState(false);

    const getFlyersDataFn = async () => {
        if (userId) {
            try {
                const response = await axios.get(`${getFlyerData}${userId}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    const data = response.data;
                    console.log(data)
                    setFlyerData(data)
                }
            } catch (error) {
                // Handle errors here
                console.error('Error fetching location list:', error);
            }
        }
    };

    const handleClick = () => {
        setIsFlyerOpen(true);
    };

    const handleClose = () => {
        setIsFlyerOpen(false);
    };

    useEffect(() => {
        getFlyersDataFn()
    }, [userId])

    function getInitials(string) {
        let words = string?.split(' ');
        let initials = words?.map(word => word.charAt(0).toUpperCase());
        return initials?.join('');
    }

    return (
        <>
            <Toast ref={toast} />
            <div
                className='kanbanContainer'
                style={{
                    paddingBottom: '2rem',
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    //   height: '100vh',
                    position: 'relative' // Needed for overlay positioning
                }}
            >
                <div
                    className='table-inner-div'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0 // Below content
                    }}
                />
                <FlexComponent flexDirection="column">
                    <FlexComponent gap="2rem" style={{ zIndex: "1", padding: "2rem" }} >
                        {flyerData?.username ? <div onClick={handleClick} className='appItem' style={{ minWidth: "350px", boxShadow: "-1px -2px 0px #ffffff40", padding: '2rem', cursor: 'pointer', background: 'rgba(255, 255, 255, 0.06)' }}>
                            <FlexComponent justifyContent="center" >
                                <Avatar image={flyerData.image} size="large" label={<span style={{ padding: '5px' }}>{!isSuperuser ? getInitials(flyerData?.full_name) : "AD"}</span>} shape="circle" style={{ marginRight: '8px' }} />
                            </FlexComponent>
                            <FlexComponent flexDirection="column" alignItems="start" gap=".3rem" style={{ marginTop: "1rem" }} >
                                {(flyerData?.first_name && flyerData?.last_name) ? <div style={{ color: "white" }} >{flyerData?.first_name} {flyerData?.last_name} </div> :
                                    <div style={{ color: "white", textTransform: "capitalize" }} >{flyerData?.username} </div>
                                }
                                <div style={{ color: "white" }} > <span style={{ color: "grey" }} >Designation: </span>  {flyerData?.designation || "N/A"}</div>
                                <div style={{ color: "white" }} > <span style={{ color: "grey" }} >NMLS ID:</span>  {flyerData?.nmls_id || "N/A"}</div>
                                <div style={{ color: "white" }} > <span style={{ color: "grey" }} >Email: </span>  {flyerData?.email || "N/A"}</div>
                            </FlexComponent>
                        </div> :
                            <div className='appItem' style={{ minWidth: "350px", boxShadow: "-1px -2px 0px #ffffff40", padding: '2rem', cursor: 'pointer', background: 'rgba(255, 255, 255, 0.06)' }}>
                                <FlexComponent justifyContent="center">
                                    <ProgressSpinner style={{ width: "50px" }} />
                                </FlexComponent>
                            </div>
                        }

                        <AppModal visible={isFlyerOpen} onHide={() => handleClose()}>
                            <FlyerPdf flyerData={flyerData} />
                        </AppModal>
                    </FlexComponent>
                </FlexComponent>

            </div>
        </>
    )
}

export default FlyerLibrary